export class DocumentPart {
  id: number;
  contents: string;
  name: string;
  document_id: number;
  created_at: string;
  updated_at: string;
  position: number;
  include_part: boolean;
  expand_part: boolean;
  is_to: boolean;
  is_cc: boolean;
  is_signature: boolean;
  is_salutation: boolean;
  is_re: boolean;
  type: string;
  expanded: boolean = false;
  isTinymce: boolean = false;
  wordCount: number = 0;
  word_count: number = 0;

  setIsTinymce(): boolean {
    switch (this.type) {
      case 'to':
        return false;
      case 'cc':
        return false;
      case 'salutation':
        return false;
      case 'signature':
        return false;
      default:
        return !this.is_to && !this.is_cc && !this.is_signature && !this.is_salutation;
    }
  }
}
